import { Concesion, ConcesionUpsert, ConcesionForm } from '@models/.';

export function transformToData(channelPermissionConcession: Concesion | null): Concesion | null {
  if (!channelPermissionConcession) return null;
  
  return {
    ...channelPermissionConcession,
  };
}

export function transformToForm(channelPermissionConcession: Concesion): ConcesionForm | undefined {
  if (!channelPermissionConcession) return;
  
  const {
    idConcesion: id,
    nombre: name,
    codigo: code,
    habilitada: enabled,
  } = channelPermissionConcession
  
  return {
    id,
    name,
    code,
    enabled,
  };
}

export function transformArrayToForm(channelPermissionConcessions?: Concesion[]): ConcesionForm[] {
  return (channelPermissionConcessions ?? []).map((channelPermissionModule) => {
    const {
      idConcesion: id,
      nombre: name,
      codigo: code,
      habilitada: enabled,
    } = channelPermissionModule
    
    return {
      id,
      name,
      code,
      enabled: !!enabled,
    };
  })
}

export function transformArrayToUpsert(channelPermissionConcessionsForm?: ConcesionForm[]): ConcesionUpsert[] {
  return (channelPermissionConcessionsForm ?? []).map((channelPermissionModule) => {
    const {
      name: nombre,
      code: codigo,
      enabled: habilitada, 
    } = channelPermissionModule
    
    return {
      nombre,
      codigo,
      habilitada,
    };
  })
}